import { Link, useSearchParams } from 'react-router-dom';

export default function Success() {
  const [params] = useSearchParams();
  const sessionId = params.get('session_id');

  return (
    <div className="max-w-2xl mx-auto px-6 py-24 text-center">
      <div className="text-6xl mb-6">🎉</div>
      <h1 className="text-3xl md:text-4xl font-bold">You're in.</h1>
      <p className="mt-6 text-slate-300 text-lg leading-relaxed">
        Welcome to DraftLion. We've sent a welcome email to the address you used at
        checkout — it confirms whether you're on the free trial or paid plan, and
        includes the setup link and the email to sign in with.
      </p>
      <p className="mt-4 text-sm text-slate-400">
        If you started a 3-day free trial: you won't be charged until day 4. You can
        cancel anytime from the <Link to="/manage" className="text-amber-400 hover:text-amber-300">Manage page</Link> with one click.
      </p>

      <div className="mt-12 rounded-xl border border-slate-800 bg-slate-900/40 p-6 text-left">
        <h2 className="font-semibold text-white">Next steps</h2>
        <ol className="mt-4 space-y-3 text-slate-300">
          <li>
            <span className="text-amber-400 font-mono mr-2">1.</span>
            Open the <Link to="/setup" className="text-amber-400 hover:text-amber-300">setup guide</Link>{' '}
            and follow the steps for Claude or ChatGPT (~5 minutes)
          </li>
          <li>
            <span className="text-amber-400 font-mono mr-2">2.</span>
            When prompted, sign in with the <strong>same email</strong> you used at checkout —
            we'll email you a one-click sign-in link
          </li>
          <li>
            <span className="text-amber-400 font-mono mr-2">3.</span>
            Ask your AI for trending fantasy adds to confirm it works
          </li>
        </ol>
      </div>

      <div className="mt-8">
        <Link to="/setup" className="btn-primary">Go to setup guide →</Link>
      </div>

      {sessionId && (
        <p className="mt-12 text-xs text-slate-600 font-mono">
          Order: {sessionId}
        </p>
      )}

      <p className="mt-12 text-sm text-slate-400">
        Need help? Email <a className="text-amber-400 hover:text-amber-300" href="mailto:support@thedraftlion.com">support@thedraftlion.com</a>{' '}
        and we'll get back to you within 24 hours.
      </p>
    </div>
  );
}
